const acquisition_reports = [
  {
    name: "Detailed Acquisition report",
    url: "/api/reports/merchant/detail-acquisition-report",
    filename: "detail_acquisition",
    file_type: "zip",
  },
  {
    name: "Circle Wise Acquisition report",
    url: "/api/reports/merchant/circle-wise-acquisition-report",
    filename: "circle_wise_acquisition",
    file_type: "xlsx",
  },
  {
    name: "Zone Wise Acquisition report",
    url: `/api/reports/merchant/zone-wise-acquisition-report`,
    filename: "zone_wise_acquisition",
    file_type: "xlsx",
  },
  {
    name: "Territory Wise Acquisition report",
    url: `/api/reports/merchant/territory-wise-acquisition-report`,
    filename: "territory_wise_acquisition",
    file_type: "xlsx",
  },
  {
    name: "Distributor Wise Acquisition report",
    url: `/api/reports/merchant/distributor-wise-acquisition-report`,
    filename: "distributor_wise_acquisition",
    file_type: "xlsx",
  },
  {
    name: "Serving Employee Wise Acquisition report",
    url: `/api/reports/merchant/serving-emp-wise-acquisition-report`,
    filename: "serving_employee_acquisition",
    file_type: "xlsx",
  },
  {
    name: "Acquiring Employee Wise Acquisition report",
    url: `/api/reports/merchant/acquiring-emp-wise-acquisition-report`,
    filename: "acquiring_empolyee_acquisition",
    file_type: "xlsx",
  },
];

export { acquisition_reports };
